import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/pages/login/Login.vue';
import SolicitarTrocarSenha from '@/components/pages/login/SolicitarTrocarSenha';
import RecuperarSenha from '@/components/pages/login/RecuperarSenha';
import Home from '@/components/pages/home/Home.vue';
import NaoAutorizado from '@/components/pages/erro/naoAutorizado/NaoAutorizado.vue';
import Erro404 from '@/components/pages/erro/erro404/Erro404.vue';
import Dashboard from '@/components/pages/dashboard/Dashboard.vue';
import ValidaDispositivo from '@/components/pages/login/ValidaDipositivo.vue';
import AtivaDispositivo from '@/components/pages/login/AtivaDispositivo.vue';
import Espelho from '@/components/pages/espelho/Espelho.vue';
import EspelhoCelular from '@/components/pages/espelho/EspelhoCelular.vue';
import Solicitacoes from '@/components/pages/solicitacoes/Solicitacoes.vue';
import SolicitacoesCelular from '@/components/pages/solicitacoes/SolicitacoesCelular.vue';
import MeusDados from '@/components/pages/usuario/MeusDados.vue';

import store from '@/plugins/store/store';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Home,
			meta: {
				loginRequerido: true,
				permissao: 0				
			},
			children: [
				{
					path: '',
					component: Dashboard,
					meta: {
						loginRequerido: true	
					}             
				},
				{
					path: '/espelho',
					component: Espelho,
					meta: {
						loginRequerido: true
					}
				},
				{
					path: '/mob/espelho',
					component: EspelhoCelular,
					meta: {
						loginRequerido: true
					}
				},
				{
					path: '/solicitacoes',
					component: Solicitacoes,
					meta: {
						loginRequerido: true
					}
				},
				{
					path: '/mob/solicitacoes',
					component: SolicitacoesCelular,
					meta: {
						loginRequerido: true
					}
				},
				{
					path: '/conta/meus-dados',
					component: MeusDados,
					meta: {
						loginRequerido: true
					}
				}
			]        
		},		
		{			
			path: '/login',
			component: Login,
			meta: {
				loginRequerido: false,				
			}             
		},
		{			
			path: '/esqueci-senha',
			component: SolicitarTrocarSenha,
			meta: {
				loginRequerido: false,				
			}             
		},
		{			
			path: '/recuperar-senha',
			component: RecuperarSenha,
			meta: {
				loginRequerido: false,				
			}             
		},
		{			
			path: '/validar',
			component: ValidaDispositivo,
			meta: {
				loginRequerido: false,				
			}             
		},
		{			
			path: '/ativar',
			component: AtivaDispositivo,
			meta: {
				loginRequerido: false,				
			}             
		},
		{
			path: '*',
			component: Erro404
		},
		{			
			path: '/nao-autorizado',
			component: NaoAutorizado,
			meta: {
				loginRequerido: false,				
			}             
		}	
	],
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});

router.beforeEach((to, from, next) => {	
	let isAutenticado = store.getters['sessao/getIsAutenticado'];		
	if(to.matched.some(record => record.meta.loginRequerido)) {			
		if(!isAutenticado) {	
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			});	
		} else {
			next();	
		}
	} else if(isAutenticado && to.path == '/login') {			
		next('/');
	} else {	
		next();
	}
});

export default router;
